{
    "examples": [
        {
            "id": "weaving_imagery",
            "ext": "jpg",
            "title": "Weaving Imagery",
            "docs": "https://docs.adacad.org/docs/learn/tutorials/figured_weaving_tc2",
            "desc": "This template offers a workflow for adding structures to color regions in an image, previewing the coloring of the image, and formatting it for weaving on a jacquard loom."
        },
        {
            "id": "harness_loom",
            "ext": "png",
            "title": "Designing for Harness Looms",
            "docs": "https://docs.adacad.org/docs/learn/tutorials/block_threading",
            "desc": "This template offers a dataflow focused on designing a threading, tieup and treadling for a four harness loom."
        },
        {
            "id": "sample7b",
            "ext": "jpg",
            "title": "Lattice Structures",
            "docs": "https://docs.adacad.org/docs/learn/examples/lattice-tutorial/",
            "desc": "We recreate one of Elizabeth Meiklejohn's Samples from the 2023 Experimental Weaving Residency in AdaCAD for those who are interesting in making stretchy, multi-layer, lattice structures"
        },
        {
            "id": "TC2_lesson1",
            "ext": "png",
            "docs": "https://docs.adacad.org/docs/learn/tutorials/weave_tc2",
            "title": "Drafting for Jacquard: Lesson 1",
            "desc": "This file can be used to make a simple draft for a jacquard loom using the rectangle and selvedge operations."
        },
        {
            "id": "first_workspace",
            "ext": "png",
            "title": "Making your First Workspace",
            "desc": "This workspace demonstrates a starting point for making workspaces in AdaCAD by chaining together one operation from each operation category and seeing what emerges"
        },
        {
            "id": "color_blending",
            "ext": "png",
            "title": "Color Blending",
            "desc": "This template shows a process for assigning structures that will blend colors between alternating warp and weft systems and colors. The blended structures are assigned to regions of an image and the user is invited to create their own color blend for the blue region."
        },
        {
            "id": "basic_operations",
            "ext": "png",
            "title": "Basic Operations",
            "desc": "This workspace contains all of the beginner level operations that AdaCAD offers"
        },
        {
            "id": "drawdownexperiments",
            "ext": "png",
            "title": "Drawdown Experiments",
            "desc": "Playing with generating drawdowns by manipulating threading and threading with sine waves and zig zags"
        }
    ]
}